var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 156,
    viewBox: "0 0 198 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_139_563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.763 1.25781H92.0411C87.0702 1.25781 83.0439 5.28403 83.0439 10.2549V51.9417H106.047C111.018 51.9417 115.044 55.9679 115.044 60.9388V83.9714H164.768L183.257 102.625L182.462 83.9714H187.763C192.734 83.9714 196.76 79.9452 196.76 74.9743V10.2549C196.76 5.28403 192.734 1.25781 187.763 1.25781Z",
    stroke: "#FF85A4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 114.959L56.9299 71.4883H59.3891L74.9992 114.959H72.8998L67.794 100.669H48.5851L43.4792 114.959H41.3799ZM67.1342 98.7496L58.3095 74.015H58.0696L49.2449 98.7496H67.1342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.626 25.5118H119.16V23.7723H142.575C142.515 37.7029 134.77 51.1236 118.26 59.2585L117.181 57.639C131.921 50.4338 139.996 38.3927 140.626 25.5193V25.5118ZM155.666 40.3421H165.21V42.0815H155.666V70.1226H153.747V17.8867H155.666V40.3421Z",
    fill: "#FF85A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3321 51.9414H106.054C111.025 51.9414 115.051 55.9676 115.051 60.9385V125.665C115.051 130.636 111.025 134.663 106.054 134.663H33.3273L14.8382 153.317L15.6329 134.663H10.3321C5.36118 134.663 1.33496 130.636 1.33496 125.665V60.9385C1.33496 55.9676 5.36118 51.9414 10.3321 51.9414Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_139_563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196.925,
    height: 154.713,
    fill: "white",
    transform: "translate(0.584961 0.507812)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.aecc867807f5ad2bad34149d93210035.svg";
export { ForwardRef as ReactComponent };